module.exports = __webpack_public_path__ + "static/media/Barlow-ExtraLightItalic.66c6f81d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Barlow-ExtraLightItalic.ttf
// module id = 2977
// module chunks = 71